{
  "appName": "Currency System",
  "platform": "Platform",
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "retry": "Retry",
    "close": "Close",
    "confirm": "Confirm",
    "apply": "Apply",
    "view": "View",
    "rotate": "Rotate",
    "reset": "Reset",
    "addItem": "Add item",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all"
  },
  "yes": "Yes",
  "no": "No",
  "nav": {
    "dashboard": "Dashboard",
    "users": "Users",
    "settings": "Settings",
    "logout": "Log out",
    "toggleSidebar": "Toggle sidebar"
  },
  "language": {
    "label": "Language",
    "ar": "العربية",
    "en": "English",
    "switchTo": {
      "ar": "Switch to Arabic",
      "en": "Switch to English"
    }
  },
  "theme": {
    "switchToLight": "Switch to light mode",
    "switchToDark": "Switch to dark mode"
  },
  "preferences": {
    "label": "Language and appearance settings"
  },
  "state": {
    "loading": "Loading…",
    "empty": "No data",
    "error": "Something went wrong"
  },
  "accessDenied": {
    "title": "You do not have access",
    "description": "Contact an administrator if you need this permission."
  },
  "pagination": {
    "page": "Page {{page}} of {{totalPages}}",
    "total": "{{total}} records",
    "next": "Next",
    "previous": "Previous"
  },
  "drawer": {
    "discardTitle": "Discard changes?",
    "discardDescription": "The information entered in this form will not be saved. This action cannot be undone.",
    "discardConfirm": "Discard changes",
    "discardCancel": "Continue editing"
  },
  "search": {
    "noResults": "No results match your search"
  },
  "selectItem": {
    "placeholder": "Select an item...",
    "selected": "Item selected"
  },
  "multiselect": {
    "selectSomeItems": "Select items"
  },
  "media": {
    "imageViewer": "Image viewer",
    "viewLarger": "View larger",
    "editImage": "Edit image",
    "cropAndAdjust": "Crop the image and adjust it",
    "zoom": "Zoom",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "rotation": "Rotation",
    "cameraCapture": "Camera capture",
    "positionInFrame": "Position yourself in the frame",
    "takePhoto": "Take photo",
    "uploadFile": "Upload file",
    "uploaded": "Uploaded",
    "dragDropImage": "Drag and drop an image here",
    "selectedLabel": "Selected",
    "deleteTitle": "Delete {{name}}?",
    "deleteMessage": "{{name}} will be removed. This cannot be undone."
  },
  "treeDemo": {
    "title": "File explorer",
    "searchPlaceholder": "Search files",
    "reports": "Reports",
    "salesReport": "Sales report",
    "inventoryReport": "Inventory report",
    "documents": "Documents",
    "invoiceTemplate": "Invoice template",
    "configurations": "Configurations"
  },
  "table": {
    "pageSizeLabel": "Rows per page",
    "actionsColumn": "Actions",
    "rowActionsLabel": "Actions for {{name}}"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "deleted": "Archived",
    "pending": "Pending",
    "closed": "Closed",
    "safe": "Safe",
    "cancelled": "Cancelled",
    "posted": "Posted"
  },
  "combobox": {
    "placeholder": "Select...",
    "search": "Search...",
    "empty": "No results",
    "clearOption": "None",
    "clearSelection": "Clear selection",
    "removeSelection": "Remove {{label}}",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_two": "{{count}} selected",
    "selectedCount_few": "{{count}} selected",
    "selectedCount_many": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "options": "Options",
    "searchOptions": "Search options"
  },
  "filterToolbar": {
    "phoneCountryCode": "Country code",
    "toggle": "Filters",
    "resetFilters": "Reset filters"
  },
  "sidebar": {
    "title": "Sidebar",
    "description": "Navigate between the system pages"
  },
  "toaster": {
    "label": "Notifications"
  }
}
